import {
  useAdvisorServiceAdvisorControllerGetAllAdvisorsKey,
  useBankingServiceBankingControllerGetAccountsKey,
  useBankingServiceBankingControllerGetDonutStatsKey,
  useBankingServiceBankingControllerGetIncomeStatsKey,
  useBankingServiceBankingControllerGetLinearStatsKey,
  useBankingServiceBankingControllerGetManualAccountKey,
  useBankingServiceBankingControllerGetSpendingStatsKey,
  useTransactionServiceTransactionControllerGetTransactionsKey,
} from '@/__generated__/queries'

import { INSIGHTS_QUERY_KEY } from '@/hooks/useInsightsQuery.hook'

export const INVALIDATE_KEYS = [
  useBankingServiceBankingControllerGetAccountsKey,
  useBankingServiceBankingControllerGetManualAccountKey,
  useAdvisorServiceAdvisorControllerGetAllAdvisorsKey,
  useBankingServiceBankingControllerGetDonutStatsKey,
  useBankingServiceBankingControllerGetIncomeStatsKey,
  useBankingServiceBankingControllerGetLinearStatsKey,
  useBankingServiceBankingControllerGetSpendingStatsKey,
  useTransactionServiceTransactionControllerGetTransactionsKey,
  INSIGHTS_QUERY_KEY,
]
